import React from 'react';
import { css } from '@emotion/react';

import { ltColors, ltFont } from './styles';

const styles = css`
  position: relative;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 24px;
  font-family: ${ltFont};
  color: ${ltColors.white};

  .lt-orb {
    width: 84px;
    height: 84px;
    border-radius: 24px;
    background: ${ltColors.pink};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 38px;
    margin-bottom: 24px;
    box-shadow: 0 10px 0 rgba(0, 0, 0, 0.18);
    animation: ltFloat 2.6s ease-in-out infinite;
  }
  .lt-orb i { animation: ltSpin 6s linear infinite; }
  h2 { font-weight: 600; font-size: 26px; margin: 0 0 8px; color: ${ltColors.white}; }
  p { font-size: 16px; opacity: 0.8; margin: 0; max-width: 360px; }
  .lt-shim {
    margin-top: 28px;
    width: 100%;
    max-width: 380px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .lt-shim span {
    height: 14px;
    border-radius: 7px;
    background: linear-gradient(90deg, rgba(255,255,255,0.08) 25%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0.08) 75%);
    background-size: 600px 100%;
    animation: ltShimmer 1.4s linear infinite;
  }
  @keyframes ltShimmer {
    0% { background-position: -300px 0; }
    100% { background-position: 300px 0; }
  }
`;

const GeneratingState: React.FC = () => (
  <div css={styles}>
    <div className='lt-orb'><i className='icon icon-refresh' aria-hidden='true' /></div>
    <h2>Crafting your takeaway</h2>
    <p>We&apos;re reading your work across the course and writing your personalized report. This only takes a moment.</p>
    <div className='lt-shim' aria-hidden='true'>
      <span style={{ width: '90%' }} />
      <span style={{ width: '100%' }} />
      <span style={{ width: '75%' }} />
      <span style={{ width: '85%' }} />
    </div>
  </div>
);

export default GeneratingState;
